module.exports = __webpack_public_path__ + "static/media/next-disabled.33f059ae.svg";